const channelOptionLabel = Object.freeze({
  generic: 'ChannelConfig_Identifier_Generic',
  twilio: 'ChannelConfig_Identifier_Twilio',
  phonovation: 'ChannelConfig_Identifier_Phonovation',
  mobivate: 'ChannelConfig_Identifier_Mobivate',
  mobivate_vortex: 'ChannelConfig_Identifier_MobivateVortex',
  ssc: 'ChannelConfig_Identifier_Ssc',
  messagebird: 'ChannelConfig_Identifier_Messagebird',
  messagebird_whatsapp: 'ChannelConfig_Identifier_MessagebirdWhatsapp',
  facebook: 'ChannelConfig_Identifier_Facebook',
  mitto: 'ChannelConfig_Identifier_Mitto',
  vonage: 'ChannelConfig_Identifier_Vonage',
  sms_studio: 'ChannelConfig_Identifier_SmsStudio',
  sinch: 'ChannelConfig_Identifier_Sinch',
  smpp: 'ChannelConfig_Identifier_Smpp',
  tola: 'ChannelConfig_Identifier_Tola',
  engage_hub: 'ChannelConfig_Identifier_EngageHub',
  etisalat: 'ChannelConfig_Identifier_Etisalat',
  eyou: 'ChannelConfig_Identifier_Eyou'
})

const channelOptionComponentName = Object.freeze({
  generic: 'Generic',
  twilio: 'Twilio',
  phonovation: 'Phonovation',
  mobivate: 'Mobivate',
  mobivate_vortex: 'MobivateVortex',
  ssc: 'Ssc',
  messagebird: 'MessageBird',
  messagebird_whatsapp: 'MessageBirdWhatsapp',
  facebook: 'Facebook',
  mitto: 'Mitto',
  vonage: 'Vonage',
  sms_studio: 'SmsStudio',
  sinch: 'Sinch',
  smpp: 'Smpp',
  tola: 'Tola',
  engage_hub: 'EngageHub',
  etisalat: 'Etisalat',
  eyou: 'Eyou'
})

export { channelOptionLabel, channelOptionComponentName }



// WEBPACK FOOTER //
// ./src/modules/channels/enum/ChannelEnums.js